import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundDealerPaymentControl.List.IRequest;
type Response = Api.Sales.ContractRefundDealerPaymentControl.List.IResponse;
type Headers = Api.Sales.ContractRefundDealerPaymentControl.List.IHeaders;
const url = '/api/Sales/ContractRefundDealerPaymentControl';
export default async function contractRefundDealerPaymentControlListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
